var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawerVisible,
            size: _vm.size,
            "custom-class": "myDrawer",
            "destroy-on-close": "",
            "before-close": _vm.handleCancel,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "customer" },
            [
              _vm._v(" 公司名称：" + _vm._s(_vm.customer_name_new) + " "),
              _vm.customer_name_new.indexOf("*") != -1
                ? _c(
                    "el-button",
                    {
                      staticStyle: { padding: "0", "margin-left": "8px" },
                      attrs: { type: "text" },
                      on: { click: _vm.watchCustomerName },
                    },
                    [_vm._v("查看")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            { attrs: { model: _vm.linkInfo, "label-width": "170px" } },
            [
              _c("h4", [_vm._v("H5链接（支持公众号、钉钉、飞书）")]),
              _vm.linkInfo.login_url
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客户专属h5地址:", prop: "login_url" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.linkInfo.login_url,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "inputStyle",
                                    staticStyle: { width: "200px" },
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.linkInfo.login_url,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.linkInfo, "login_url", $$v)
                                      },
                                      expression: "linkInfo.login_url",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.copyNumber(_vm.linkInfo.login_url)
                                },
                              },
                            },
                            [_vm._v("复制 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.linkInfo.login_url
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "url-code",
                      attrs: { label: "专属公众号二维码:", prop: "login_logo" },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", { staticStyle: { "margin-right": "20px" } }, [
                          _vm.linkInfo.login_url
                            ? _c(
                                "div",
                                { staticClass: "h5-url" },
                                [
                                  _c("qr-code", {
                                    ref: "Qrcode",
                                    attrs: {
                                      "app-src": _vm.linkInfo.login_url,
                                      size: 170,
                                      exportSize: 680,
                                    },
                                    on: { qrBack: _vm.getCodeUrl },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            [
                              _vm._v(" 风格一： "),
                              _vm.linkInfo.login_url
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downImg(_vm.login_url, "")
                                        },
                                      },
                                    },
                                    [_vm._v("下载图片 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticStyle: { "margin-right": "20px" } }, [
                          _vm.linkInfo.login_url
                            ? _c(
                                "div",
                                { staticClass: "h5-url" },
                                [
                                  _c("qr-code", {
                                    ref: "Qrcode",
                                    attrs: {
                                      "app-src": _vm.linkInfo.login_url,
                                      size: 170,
                                      exportSize: 680,
                                      "logo-src": _vm.linkInfo.logo,
                                    },
                                    on: { qrBack: _vm.getCodeUrl1 },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            [
                              _vm._v(" 风格二：渠道级logo "),
                              _vm.linkInfo.login_url
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downImg(
                                            _vm.login_url1,
                                            "渠道级logo"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("下载图片 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticStyle: { "margin-right": "20px" } }, [
                          _vm.linkInfo.login_url
                            ? _c(
                                "div",
                                {
                                  staticClass: "h5-url",
                                  staticStyle: { position: "relative" },
                                },
                                [
                                  _c("qr-code", {
                                    ref: "Qrcode",
                                    attrs: {
                                      "app-src": _vm.linkInfo.login_url,
                                      size: 170,
                                      exportSize: 680,
                                      "logo-src": _vm.linkInfo.account_logo
                                        ? _vm.linkInfo.account_logo
                                        : "",
                                    },
                                    on: { qrBack: _vm.getCodeUrl2 },
                                  }),
                                  !_vm.linkInfo.account_logo
                                    ? _c("div", { staticClass: "no-logo" }, [
                                        _c("p", [_vm._v("暂无客户logo")]),
                                        _c("p", [
                                          _vm._v("请至「图片配置」页面"),
                                        ]),
                                        _c("p", [_vm._v("传登录页logo")]),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            [
                              _vm._v(" 风格三：客户级logo "),
                              _vm.linkInfo.login_url &&
                              _vm.linkInfo.account_logo
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downImg(
                                            _vm.login_url2,
                                            "客户级logo"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("下载图片 ")]
                                  )
                                : _vm._e(),
                              _vm.hasTabAuth("5") &&
                              _vm.linkInfo.login_url &&
                              !_vm.linkInfo.account_logo
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: { click: _vm._jumpSet },
                                    },
                                    [_vm._v("跳转配置 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("el-divider"),
              _vm.linkInfo.mini_program_page
                ? _c("h4", [_vm._v("微信小程序链接")])
                : _vm._e(),
              _vm.linkInfo.mini_program_page
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "客户专属小程序地址:",
                        prop: "mini_program_page",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.linkInfo.mini_program_page,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "inputStyle",
                                    staticStyle: { width: "200px" },
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.linkInfo.mini_program_page,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.linkInfo,
                                          "mini_program_page",
                                          $$v
                                        )
                                      },
                                      expression: "linkInfo.mini_program_page",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.copyNumber(
                                    _vm.linkInfo.mini_program_page
                                  )
                                },
                              },
                            },
                            [_vm._v("复制 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.linkInfo.mini_program_img_base64
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "专属小程序链接:",
                        prop: "mini_program_img_base64",
                      },
                    },
                    [
                      _vm.linkInfo.mini_program_img_base64
                        ? _c("img", {
                            staticStyle: { width: "220px", height: "230px" },
                            attrs: {
                              src: _vm.linkInfo.mini_program_img_base64,
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        [
                          _vm.linkInfo.mini_program_img_base64
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downImg1(
                                        _vm.linkInfo.mini_program_img_base64
                                      )
                                    },
                                  },
                                },
                                [_vm._v("下载图片 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c("el-divider"),
              _vm.linkInfo.h5_login_url
                ? _c("h4", [_vm._v("浏览器链接")])
                : _vm._e(),
              _vm.linkInfo.h5_login_url
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "客户专属浏览器地址:",
                        prop: "h5_login_url",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.linkInfo.h5_login_url,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "inputStyle",
                                    staticStyle: { width: "200px" },
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.linkInfo.h5_login_url,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.linkInfo,
                                          "h5_login_url",
                                          $$v
                                        )
                                      },
                                      expression: "linkInfo.h5_login_url",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.copyNumber(
                                    _vm.linkInfo.h5_login_url
                                  )
                                },
                              },
                            },
                            [_vm._v("复制 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }